import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { EVENT_ID } from '../constants';
import swal from 'sweetalert';

Amplify.configure(awsconfig);

const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
});

class JoinPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      name: '',
      // password: '',
      testVal: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
  }

  componentDidMount() {
    console.log(this.props);
  }

  handleSignUp() {
    console.log(this.state);
    Auth.signUp({
      // username: EVENT_ID + '_' + this.state.email + '||' + encrypt(this.state.email),
      username: EVENT_ID + '_' + this.state.email,
      password: this.state.email,
      attributes: {
        email: this.state.email,
        'custom:in_name': this.state.name,
        'custom:role': 'user',
        'custom:evt': EVENT_ID,
      },
    })
      .then((user) => {
        // console.log(user);
        swal('등록되었습니다.').then(() => {
          this.setState(
            {
              email: '',
              name: '',
            },
            () => {
              this.props.history.push('/signin');
            },
          );
        });
      })
      .catch((err) => {
        console.log(err);
        swal('등록에 실패하였습니다. 다시 등록해 주세요');
      });
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <form className={classes.form} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoComplete="name"
                  name="name"
                  variant="outlined"
                  required
                  fullWidth
                  id="name"
                  label="Name"
                  autoFocus
                  onChange={(e) => this.handleChange('name', e)}
                  value={this.state.name}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  // autoComplete="email"
                  onChange={(e) => this.handleChange('email', e)}
                  value={this.state.email}
                />
              </Grid>
              {/* <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="text"
                  id="password"
                  autoComplete="current-password"
                  onChange={(e) => this.handleChange('password', e)}
                  value={this.state.password}
                />
              </Grid> */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox value="allowExtraEmails" color="primary" />}
                  label="I want to receive inspiration, marketing promotions and updates via email."
                />
              </Grid>
            </Grid>
            <Button fullWidth variant="contained" color="primary" className={classes.submit} onClick={this.handleSignUp}>
              Sign Up
            </Button>
            <Grid container justify="flex-end">
              <Grid item>
                <Link to="/signin">Already have an account? Sign in</Link>
              </Grid>
            </Grid>
          </form>
        </div>
        {/* <Box mt={5}>COPYRIGHT</Box> */}
      </Container>
    );
  }
}

export default withStyles(styles, { withTheme: true })(JoinPage);
